import type { InjectionKey } from 'vue';

/** Set by `NxTileGrid`: its tiles are the items of its list. */
export const tileGridKey: InjectionKey<true> = Symbol('nx-tile-grid');
